import loadingMixin from './loading';
import scrollUp from './scrollUp';

export default {
  /**
   * All multistep forms need loading states.
   */
  mixins: [loadingMixin, scrollUp],
  /**
   * Data
   */
  data: {
    // active step
    step: 1,
  },
  /**
   * Methods
   */
  methods: {
    /**
     * Make sure you set <transition v-on:after-enter="afterEnter">
     * After a transition has finished, resolve the transition promise.
     */
    afterEnter() {
      if (this.transitionPromise && this.transitionPromiseResolver) {
        this.transitionPromiseResolver();
      }

      Vue.nextTick(() => {
        // set focus if there's a specific element that should be focused for live text reading, or
        // set focus on the first field in the next step if it exists
        const stepFocus = this.$refs.step2focus;
        const stepInput = document.querySelector('.step input, .step select');
        if (stepFocus) {
          stepFocus.focus();
        } else if (stepInput) {
          stepInput.focus();
        }

        // scroll to the top of the vue app
        this.scrollUp();
      });
    },
    /**
     * Next Step function
     * @return {Promise} promise If going to the next step results in a css animation using the <transition>,
     * the promise will resolve when the animation is completed.
     * You can then use this like this.nextStep().then(() => { ... });
     * This is helpful in ensuring any elements included in a v-if are actually in the DOM.
     * @see afterEnter
     */
    nextStep(e) {
      this.transitionPromise = new Promise(resolve => {
        this.transitionPromiseResolver = resolve;
        // update form progress
        for (let i = 0; i <= this.step; i += 1) {
          Event.$emit('progress', {
            step: `${i}`,
            status: 'completed',
          });
        }

        this.step += 1;

        Event.$emit('progress', {
          step: `${this.step}`,
          status: 'active',
        });

        // sometimes the event is handled earlier in the process
        if (e && e.preventDefault) {
          e.preventDefault();
        }
      });

      return this.transitionPromise;
    },

    /**
     * Set step explicitly.
     * @param {*} stepNum
     */
    setStep(stepNum, e) {
      this.transitionPromise = new Promise(resolve => {
        this.transitionPromiseResolver = resolve;
        // update form progress
        for (let i = 0; i < stepNum; i += 1) {
          Event.$emit('progress', {
            step: `${i}`,
            status: 'completed',
          });
        }

        this.step = stepNum;

        Event.$emit('progress', {
          step: `${this.step}`,
          status: 'active',
        });

        // sometimes the event is handled earlier in the process
        if (e && e.preventDefault) {
          e.preventDefault();
        }
      });

      return this.transitionPromise;
    },

    /**
     * Previous step function
     */
    previousStep(e) {
      this.transitionPromise = new Promise(resolve => {
        this.transitionPromiseResolver = resolve;
        // only go back if we have a pervious step
        if (this.step !== 1) {
          Event.$emit('progress', {
            step: `${this.step}`,
            status: 'inactive',
          });

          this.step -= 1;

          Event.$emit('progress', {
            step: `${this.step}`,
            status: 'active',
          });
        }

        if (e && e.preventDefault) {
          e.preventDefault();
        }
      });

      return this.transitionPromise;
    },

    setStepQuietly(stepNum, e) {
      this.transitionPromise = new Promise(resolve => {
        this.transitionPromiseResolver = resolve;
        this.step = stepNum

        if (e && e.preventDefault) {
          e.preventDefault();
        }
      });
      return this.transitionPromise;
    },

    setStepAndMarkComplete(stepNum, e) {
      this.transitionPromise = new Promise(resolve => {
        this.transitionPromiseResolver = resolve;
        // update form progress
        for (let i = 0; i <= stepNum; i += 1) {
          Event.$emit('progress', {
            step: `${i}`,
            status: 'completed',
          });
        }

        this.step = stepNum;

        // sometimes the event is handled earlier in the process
        if (e && e.preventDefault) {
          e.preventDefault();
        }
      });

      return this.transitionPromise;
    },

    setStepAndMarkInactive(stepNum, e) {
      this.transitionPromise = new Promise(resolve => {
        this.transitionPromiseResolver = resolve;
        // update form progress
        for (let i = this.step; i > stepNum; i -= 1) {
          Event.$emit('progress', {
            step: `${i}`,
            status: 'inactive',
          });
        }

        this.step = stepNum;

        Event.$emit('progress', {
          step: `${this.step}`,
          status: 'active',
        });

        // sometimes the event is handled earlier in the process
        if (e && e.preventDefault) {
          e.preventDefault();
        }
      });

      return this.transitionPromise;
    },

  },

  /**
   * Mounted
   */
  mounted() {
    // multistep forms set initial step.
    if (typeof this.step !== "undefined") {
      Vue.nextTick(() => {
        // set first step in form progress bar to active.
        Event.$emit('progress', {
          step: "1",
          status: 'active',
        });
      });
    }
  },
}



// WEBPACK FOOTER //
// ./src/assets/toolkit/scripts/shared/vue/mixins/multistep.js